import template from 'js/pages/routes/before-lines-content/index.pug'

export default Vue.extend({
  name: 'routes-before-lines-content-page',
  template: template()
})
